import axios from 'axios'

// Get signature details
const get = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/signature`)
  return data
}

// Create signature
const create = async (id, price) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature`, {
    id,
    price
  })
  return data
}

const payment = async (signature, name, product, price) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature/payment`, {
    signature,
    name,
    product,
    price
  })
  return data
}

const paymentCard = async (signature, name, product, price, creditNumber, creditValidity, creditName, creditCVV, installment) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature/payment/card`, {
    signature,
    name,
    product,
    price,
    creditNumber,
    creditValidity,
    creditName,
    creditCVV,
    installment
  })
  return data
}

// Update signature details
const update = async (name, email, phone, newsletter) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/signature/user`, {
    name,
    email,
    phone,
    newsletter
  })
  return data
}

export {
  get,
  create,
  payment,
  paymentCard,
  update
}
